window.VH = window.VH === undefined ? {} : window.VH;
VH.AjaxLoad = {
    load : function load(container) {
        let _t = VH.AjaxLoad,
            t = (typeof container) === 'string' ? $(container) : container,
            url = t.data('url'),
            params = t.data('url-params')
        ;

        params = params !== undefined ? params : {};

        $.get(url, params, function (data) {
            t.html(data);
        });

        if (t.hasClass('ajaxLoadActive')) {
            t.on('click', 'a', function () {
                let href = $(this).attr('href');
                if (href.substring(0, 1) !== '#') {
                    $.get(href, function (data) {
                        t.html(data);
                    });
                }
                return false;
            });
        }
    },

    init : function init() {
        let _t = VH.AjaxLoad;

        $('.ajaxLoad').each(function () {
            let t = $(this);
            _t.load(t);
        });
    }
};